import { IdPathBuilder, Raw_Id_Path_Head } from "../../navigation/IdPathBuilder";

export function deepLinkTo(views: string, view: string, context: IdPathBuilder): string {
	const properties = parseHash();
	properties.set("vs", views);
	properties.set("v", view);
	properties.set("c", keysOfIdPath(context));
	return serializeHash(properties);
}

const context_separator = ">";
const context_escape = "*";
const separator_regex = new RegExp(context_separator, "g");
const escape_regex = new RegExp(`\\${context_escape}`, "g");

function keysOfIdPath(id: IdPathBuilder): string {
	const result: string[] = [];
	const walk = (step: Raw_Id_Path_Head) => {
		switch (step["has steps"][0]) {
			case "no":
				break;
			case "yes": {
				const yes = step["has steps"][1];
				switch (yes.type[0]) {
					case "collection entry": {
						const entry = yes.type[1];
						result.push(
							entry.id
								.replace(escape_regex, context_escape + context_escape)
								.replace(separator_regex, context_escape + context_separator)
						);
						break;
					}
					case "group":
						break;
					case "state":
						break;
					default:
						unexpectedState(yes.type[0]);
				}
				walk(yes.tail);
				break;
			}
			default:
				unexpectedState(step["has steps"][0]);
		}
	};
	walk(id.build());
	return result.join(context_separator);
}

export function parseKeys(s: string): string[] {
	const result: string[] = [];
	let part = "";
	for (let i = 0; i < s.length; i += 1) {
		const c = s[i];
		if (c === context_escape) {
			const next_c = s[i + 1];
			if (next_c === undefined) {
				part += c;
			} else if (next_c === context_escape) {
				part += next_c;
				i += 1;
			} else if (next_c === context_separator) {
				part += next_c;
				i += 1;
			}
		} else if (c === context_separator) {
			result.push(part);
			part = "";
		} else {
			part += c;
		}
	}
	if (part.length > 0) {
		result.push(part);
	}
	return result;
}

export function clearDeepLink(): string {
	const properties = parseHash();
	properties.delete("vs");
	properties.delete("v");
	properties.delete("c");
	rewriteHash(properties);
	return serializeHash(properties);
}

export function setUpdated(): void {
	const properties = parseHash();
	properties.set("updated", "updated");
	rewriteHash(properties);
}

export function clearUpdated(): void {
	const properties = parseHash();
	properties.delete("updated");
	rewriteHash(properties);
}

export function getUpdated(): string | null {
	return parseHash().get("updated");
}

export function getDeepLink(): { views: string; view: string; context: string } | undefined {
	const properties = parseHash();
	const views = properties.get("vs");
	const view = properties.get("v");
	const context = properties.get("c");
	if (views !== null && view !== null && context !== null) {
		return {
			views: views,
			view: view,
			context: context,
		};
	} else {
		return undefined;
	}
}

export function getLanguage(): string | null {
	return parseHash().get("lang");
}

export function clearLanguage(): void {
	const properties = parseHash();
	properties.delete("lang");
	rewriteHash(properties);
}

export function getUserName(): string | null {
	return parseHash().get("u");
}

export function getToken(): string | null {
	return parseHash().get("t");
}

export function getDebug(): boolean {
	return parseHash().get("debug") !== null;
}

export function clearToken(): void {
	const properties = parseHash();
	properties.delete("t");
	rewriteHash(properties);
}

export function clearUsername(): void {
	const properties = parseHash();
	properties.delete("u");
	rewriteHash(properties);
}

export function getDevserverPort(): string | null {
	return parseHash().get("dev-server-port");
}

export function clearDevserverPort(): void {
	const properties = parseHash();
	properties.delete("dev-server-port");
	rewriteHash(properties);
}

function parseHash() {
	return new URLSearchParams(window.location.hash.slice(1));
}

function serializeHash(properties: Record<string, string> | URLSearchParams) {
	return new URLSearchParams(properties).toString();
}

function rewriteHash(properties: URLSearchParams) {
	window.location.hash = serializeHash(properties);
}
